(function () {
	const initCollapsibleContent = () => {
		$(".collapsible-content__toggle:not(.accordion-disabled)").each(function (index, element) {
			if ($(this).hasClass("content_started")) {
				return "";
			}
			$(this).addClass("content_started");
			$(element).on("click", function () {
				const parent = $(this).parent();
				if (parent.hasClass("active")) {
					const accordionId = parent.attr('id');
					const hasImage = document.querySelector(`.custom-collapsible-content-image.${accordionId}`);
					if (!hasImage) {
						parent.removeClass("active");
						$(this).next().stop().slideUp(300);
						if (document.querySelector(`.${parent[0].id}`)) {
							document.querySelector(`.${parent[0].id}`).style.display = "none";
						}
					}
				} else {
					if (parent.siblings(".collapsible-content__item.active")) {
						if (document.querySelector(`.${parent.siblings(".collapsible-content__item.active")[0]?.id}`)) {
							document.querySelector(`.${parent.siblings(".collapsible-content__item.active")[0].id}`).style.display = "none";
						}
						parent.siblings(".collapsible-content__item.active").removeClass("active");
					}
					if (document.querySelector(`.${parent[0].id}`)) {
						document.querySelector(`.${parent[0].id}`).style.display = "block";
					}
					parent.addClass("active");
					$(this).closest(".collapsible-content__items").find(".collapsible-content__answer").stop().slideUp(300);
					$(this).next().stop().slideDown(300);
				}
			});
		});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	initCollapsibleContent();
})();
